import { render, staticRenderFns } from "./EditProcedureDialog.vue?vue&type=template&id=4757507d&scoped=true&"
import script from "./EditProcedureDialog.vue?vue&type=script&lang=js&"
export * from "./EditProcedureDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4757507d",
  null
  
)

export default component.exports